import { Check, Minus } from 'tabler-icons-react';

export const isEnableToColumn = isEnable => (isEnable ? <Check size={20} /> : <Minus size={20} />);
